// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBMR8ObKakLH_zbUvMPeXz-25NkCltpnsQ",
    authDomain: "safeline-5c7bc.firebaseapp.com",
    databaseURL: "https://safeline-5c7bc-default-rtdb.firebaseio.com",
    projectId: "safeline-5c7bc",
    storageBucket: "safeline-5c7bc.firebasestorage.app",
    messagingSenderId: "777769026277",
    appId: "1:777769026277:web:a953c94733282f78478a0c",
    measurementId: "G-NSSS07CHV0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };